"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelBookingRequestSchema = exports.BookingRequestSchema = void 0;
const zod_1 = require("zod");
// An explicit z.ZodObject<Shape> annotation truncates the generated .d.ts to a partial generic;
// consumers with strictNullChecks:false (e.g. routing-functions) then recompute Output/Input and
// every field turns optional. Leave this to inference so the compiled .d.ts bakes in the full,
// consumer-proof type.
exports.BookingRequestSchema = zod_1.z.object({
    restAreaId: zod_1.z.string(),
    grossPrice: zod_1.z.number().finite().nonnegative(),
    arrivalTime: zod_1.z.string(),
    endTime: zod_1.z.string(),
    phone: zod_1.z.string(),
    licensePlate: zod_1.z.string(),
});
// Same reason as BookingRequestSchema above.
exports.CancelBookingRequestSchema = zod_1.z.object({
    bookingId: zod_1.z.string(),
    reason: zod_1.z.string().optional(),
});
//# sourceMappingURL=bookingRequest.js.map